import React from "react"
import { connect } from "react-redux"

import AlertContainer from "./AlertContainer"

const Alerts = ({ alerts }) => (
    <div className="alert-container">
        {alerts.map(alert => <AlertContainer key={alert.id} {...alert} />)}
    </div>
)

const mapStateToProps = ({ alerts }) => ({ alerts })

export default connect(mapStateToProps)(Alerts)
